import React from 'react';

import CSSModules from 'react-css-modules';

import type {BaseObject, CanvasSize} from '../../types';

import styles from '../styles.module.scss';

interface StickerObjectProps<T extends BaseObject> {
  object: Extract<T, {type: 'sticker'}>;
  canvasSize: CanvasSize;
}

const StickerObjectComponent = <T extends BaseObject>({
  object,
  canvasSize,
}: StickerObjectProps<T>) => {
  const {width, height} = canvasSize;

  return (
    <span
      styleName='emoji'
      style={{
        width: (width * object.styles.width) / 9,
        height: (height * object.styles.height) / 16,
      }}
    >
      <img alt='' draggable='false' src={object.url} />
    </span>
  );
};

export const StickerObject = CSSModules(StickerObjectComponent, styles);
